<template>
  <div>
    <!-- <van-nav-bar >
        <template #left>
            <van-icon color="#242934" name="arrow-left" @click="back"/>
        </template>
    </van-nav-bar> -->
    <p class="title">投诉须知</p>
    <p class="tip">1、您的投诉需要基于公平公正，且是善意的。</p>
    <p class="tip">2、您的投诉需要有足够的证据能够表明您的投诉是有效的。</p>
    <p class="tip">3、数企作为中立的平台服务，在收到您的投诉后，会尽快按照相关法律法规的规定独立判断并进行处理，将会在</p>
    <p class="tip">4、数企将采取合理的措施保护你的个人信息。</p>
    <p class="tip">5、除法律法规规定的情形外，未经用户许可，数企不会相第三方公开，披露您的个人信息。</p>
  </div>
</template>

<script>
import head from '@/mixins/head';
export default {
    mixins: [ head ],
    methods: {
        back() {
            this.$router.back();
        }
    }
};
</script>

<style lang="scss" scoped >
.title{
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #242934;
    line-height: 22px;
    margin: 31px 22px;
    text-align: left;
}
.tip{
    font-size: 14px;
    font-family: Montserrat-Regular, Montserrat;
    font-weight: 400;
    color: #242934;
    line-height: 27px;
    margin: 0 22px;
    text-align: left;
}
</style>
